@use '@lib/assets/styles/main.scss' as *;

.rootTextCell {
  display: block;
}

.croppedTextSingleLine {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.croppedTextMultiLine {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.disabled {
  @extend %disabledGrayscale;
}
